<template>
  <v-row align="center" class="fill-height" justify="center">
    <v-col cols="12" lg="6" md="8" sm="10" xl="4">
      <SignupForm />
    </v-col>
  </v-row>
</template>

<script>
import SignupForm from '@/components/SignupForm'

export default {
  name: 'Signup',
  components: {
    SignupForm,
  },
}
</script>

<style scoped></style>
